import React, { useEffect, useState } from 'react';
import { Card, Table, Badge, Button, Modal, Form, Alert } from 'react-bootstrap';
import PageLayout from '../../layouts/PageLayout';
import { useBranch, useBranchAPI } from '../../hooks';
import { taskAPI } from '../../services';
import { toast } from 'react-toastify';

export default function TaskAdminReviewPage() {
  const { withBranch } = useBranchAPI();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [form, setForm] = useState({
    decision: 'APPROVE_REVIEWER',
    admin_notes: '',
    assignee_points_delta: 0,
    reviewer_points_delta: 0,
  });

  const loadData = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await withBranch(taskAPI.getAdminReviewPending, { page: 1, limit: 50 });
      const payload = res.data || res;
      const list = payload.data || payload || [];
      setItems(Array.isArray(list) ? list : []);
    } catch (err) {
      console.error('Error loading admin review pending tasks:', err);
      setError('Không thể tải danh sách task chờ admin duyệt');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const openReview = (item) => {
    setSelectedItem(item);
    setForm({
      decision: 'APPROVE_REVIEWER',
      admin_notes: '',
      assignee_points_delta: 0,
      reviewer_points_delta: 0,
    });
    setShowModal(true);
  };

  const openPreview = (url) => {
    if (!url) return;
    setPreviewUrl(url);
  };

  const handleSubmit = async () => {
    if (!selectedItem) return;
    try {
      setLoading(true);
      const payload = {
        decision: form.decision,
        admin_notes: form.admin_notes || undefined,
      };
      if (form.decision === 'CUSTOM') {
        payload.assignee_points_delta = Number(form.assignee_points_delta || 0);
        payload.reviewer_points_delta = Number(form.reviewer_points_delta || 0);
      }
      await taskAPI.adminReviewShiftTask(selectedItem.id, payload);
      toast.success('Đã phân xử tranh chấp');
      setShowModal(false);
      await loadData();
    } catch (err) {
      console.error('Error admin reviewing shift task:', err);
      toast.error('Không thể phân xử tranh chấp');
    } finally {
      setLoading(false);
    }
  };


  return (
    <PageLayout>
      <div className="mc-page">
        <div className="mc-page-header">
          <div className="mc-page-header-title">
            <h1>Phân xử tranh chấp Task</h1>
          </div>
        </div>

        <Card className="mc-card">
          <Card.Header>
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Danh sách task có tranh chấp chờ phân xử</h5>
              {loading && <span className="text-muted small">Đang tải...</span>}
            </div>
          </Card.Header>
          <Card.Body>
            {error && <Alert variant="danger">{error}</Alert>}
            {!loading && items.length === 0 && !error && (
              <div className="text-center text-muted py-4">Không có task nào có tranh chấp chờ phân xử.</div>
            )}
            {items.length > 0 && (
              <Table
                responsive
                hover
              >
                <thead>
                  <tr>
                    <th>Task</th>
                    <th>Nhân viên</th>
                    <th>Reviewer</th>
                    <th>Kết quả review</th>
                    <th>QC Reviewer</th>
                    <th>Kết quả QC review</th>
                    <th>Trạng thái</th>
                    <th>Thời gian review</th>
                    <th>Điểm</th>
                    <th>Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item) => {
                    const task = item.task || {};
                    const employee = item.employee || {};
                    const reviewer = item.reviewer || {};
                    const qcReviewer = item.qc_reviewer || {};
                    const reviewResult = item.review_result || '-';
                    const qcReviewResult = item.qc_review_result || '-';
                    const points = task.points ?? 0;
                    const taskType = task.task_type || 'SUB_TASK';
                    return (
                      <tr key={item.id}>
                        <td>
                          <div className="fw-semibold d-flex align-items-center gap-2">
                            {task.name || task.id}
                            {taskType === 'MAIN_TASK' ? (
                              <Badge bg="primary" className="ms-1">Việc trực ca</Badge>
                            ) : (
                              <Badge bg="secondary" className="ms-1">Việc phải nghiệm thu</Badge>
                            )}
                          </div>
                          <small className="text-muted">{item.id}</small>
                        </td>
                        <td>
                          <div className="fw-semibold">{employee.full_name || employee.name || employee.id}</div>
                        </td>
                        <td>
                          <div className="fw-semibold">{reviewer.full_name || reviewer.name || reviewer.id}</div>
                        </td>
                        <td>
                          <Badge
                            bg={
                              reviewResult === 'APPROVED'
                                ? 'success'
                                : reviewResult === 'REJECTED_AND_FIXED'
                                ? 'danger'
                                : 'secondary'
                            }
                          >
                            {reviewResult}
                          </Badge>
                        </td>
                        <td>
                          {qcReviewer.full_name || qcReviewer.username ? (
                            <div className="fw-semibold">{qcReviewer.full_name || qcReviewer.username}</div>
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                        <td>
                          {qcReviewResult !== '-' ? (
                            <Badge
                              bg={
                                qcReviewResult === 'APPROVED'
                                  ? 'success'
                                  : qcReviewResult === 'REJECTED_AND_FIXED'
                                  ? 'danger'
                                  : 'secondary'
                              }
                            >
                              {qcReviewResult}
                            </Badge>
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                        <td>
                          <Badge
                            bg={
                              item.status === 'WAITING_ADMIN_DECISION'
                                ? 'warning'
                                : item.status === 'APPEALING'
                                ? 'danger'
                                : 'secondary'
                            }
                          >
                            {item.status}
                          </Badge>
                        </td>
                        <td>
                          <small className="text-muted">{item.reviewed_at}</small>
                        </td>
                        <td>
                          {task.has_points ? (
                            <Badge bg={points >= 0 ? 'success' : 'danger'}>
                              {points >= 0 ? '+' : ''}
                              {points}
                            </Badge>
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                        <td>
                          <Button
                            size="sm"
                            variant="outline-primary"
                            onClick={() => openReview(item)}
                          >
                            Phân xử
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            )}
          </Card.Body>
        </Card>

        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Phân xử tranh chấp</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedItem && (
              <>
                <p className="mb-2">
                  <strong>Task:</strong> {selectedItem.task?.name}
                </p>
                <p className="mb-2">
                  <strong>Nhân viên:</strong> {selectedItem.employee?.full_name}
                </p>
                <p className="mb-2">
                  <strong>Reviewer:</strong> {selectedItem.reviewer?.full_name}
                </p>

                {Array.isArray(selectedItem.evidence_urls) && selectedItem.evidence_urls.length > 0 && (
                  <div className="mb-3">
                    <strong>Bằng chứng nhân viên:</strong>
                    <div className="d-flex flex-wrap gap-2 mt-2">
                      {selectedItem.evidence_urls.map((url, idx) => (
                        <button
                          key={idx}
                          type="button"
                          className="btn p-0 border-0"
                          onClick={() => openPreview(url)}
                        >
                          <img
                            src={url}
                            alt={`evidence-${idx}`}
                            style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 4 }}
                          />
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {Array.isArray(selectedItem.review_evidence_urls) && selectedItem.review_evidence_urls.length > 0 && (
                  <div className="mb-3">
                    <strong>Bằng chứng reviewer:</strong>
                    <div className="d-flex flex-wrap gap-2 mt-2">
                      {selectedItem.review_evidence_urls.map((url, idx) => (
                        <button
                          key={idx}
                          type="button"
                          className="btn p-0 border-0"
                          onClick={() => openPreview(url)}
                        >
                          <img
                            src={url}
                            alt={`review-evidence-${idx}`}
                            style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 4 }}
                          />
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {selectedItem.qc_reviewer && (
                  <div className="mb-3">
                    <hr />
                    <h6 className="mb-2">Thông tin QC Review</h6>
                    <p className="mb-2">
                      <strong>QC Reviewer:</strong>{' '}
                      {selectedItem.qc_reviewer.full_name || selectedItem.qc_reviewer.username || '-'}
                    </p>
                    {selectedItem.qc_reviewed_at && (
                      <p className="mb-2">
                        <strong>Thời gian QC review:</strong> {new Date(selectedItem.qc_reviewed_at).toLocaleString('vi-VN')}
                      </p>
                    )}
                    {selectedItem.qc_review_result && (
                      <p className="mb-2">
                        <strong>Kết quả QC review:</strong>{' '}
                        <Badge
                          bg={
                            selectedItem.qc_review_result === 'APPROVED'
                              ? 'success'
                              : selectedItem.qc_review_result === 'REJECTED_AND_FIXED'
                              ? 'danger'
                              : 'secondary'
                          }
                        >
                          {selectedItem.qc_review_result}
                        </Badge>
                      </p>
                    )}
                    {selectedItem.qc_review_notes && (
                      <p className="mb-2">
                        <strong>Ghi chú QC review:</strong> {selectedItem.qc_review_notes}
                      </p>
                    )}
                    {Array.isArray(selectedItem.qc_review_video_urls) &&
                      selectedItem.qc_review_video_urls.length > 0 && (
                        <div className="mb-2">
                          <strong>Video QC review:</strong>
                          <div className="d-flex flex-wrap gap-2 mt-2">
                            {selectedItem.qc_review_video_urls.map((url, idx) => (
                              <div
                                key={idx}
                                className="position-relative"
                              >
                                <video
                                  controls
                                  style={{ width: 200, maxHeight: 150, borderRadius: 4 }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    window.open(url, '_blank');
                                  }}
                                >
                                  <source
                                    src={url}
                                    type="video/mp4"
                                  />
                                  Trình duyệt không hỗ trợ video.
                                </video>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                  </div>
                )}

                <Form.Group className="mb-3">
                  <Form.Label>Quyết định phân xử</Form.Label>
                  <Form.Select
                    value={form.decision}
                    onChange={(e) => setForm({ ...form, decision: e.target.value })}
                  >
                    <option value="APPROVE_REVIEWER">Đồng ý với reviewer (A bị phạt, B nhận điểm)</option>
                    <option value="REJECT_REVIEWER"> Từ chối</option>
                    <option value="CUSTOM">Tùy chỉnh điểm cho cả A và B</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Ghi chú admin</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={form.admin_notes}
                    onChange={(e) => setForm({ ...form, admin_notes: e.target.value })}
                    placeholder="Ghi chú nội dung duyệt (optional)"
                  />
                </Form.Group>

                {form.decision === 'CUSTOM' && (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Label>Điểm cho người làm (có thể âm hoặc dương)</Form.Label>
                      <Form.Control
                        type="number"
                        value={form.assignee_points_delta}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            assignee_points_delta: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Điểm cho reviewer (có thể âm hoặc dương)</Form.Label>
                      <Form.Control
                        type="number"
                        value={form.reviewer_points_delta}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            reviewer_points_delta: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Hủy
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? 'Đang lưu...' : 'Xác nhận phân xử'}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={Boolean(previewUrl)}
          onHide={() => setPreviewUrl(null)}
          size="lg"
          centered
        >
          <Modal.Body className="text-center">
            {previewUrl && (
              <img
                src={previewUrl}
                alt="preview"
                style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
              />
            )}
          </Modal.Body>
        </Modal>
      </div>
    </PageLayout>
  );
}
